import { render, staticRenderFns } from "./ChooseHub.vue?vue&type=template&id=2678b07c&scoped=true&"
import script from "./ChooseHub.vue?vue&type=script&lang=js&"
export * from "./ChooseHub.vue?vue&type=script&lang=js&"
import style0 from "./ChooseHub.vue?vue&type=style&index=0&id=2678b07c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2678b07c",
  null
  
)

export default component.exports